import { motion } from 'framer-motion';

const items = ['Roofing', 'Impact Windows', 'HVAC', 'Remodeling', 'New Construction', 'General Contractor', 'Electrical'];

export default function Marquee() {
  return (
    <div className="py-6 border-y border-white/5 overflow-hidden">
      <motion.div className="flex whitespace-nowrap" animate={{ x: [0, -1920] }} transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}>
        {[...items, ...items, ...items, ...items].map((item, i) => (
          <span key={i} className="inline-flex items-center gap-6 mx-6">
            <span className="font-display font-black text-2xl sm:text-3xl tracking-tight text-white/10 uppercase">{item}</span>
            <span className="w-2 h-2 bg-[#E31937]/40 rotate-45" />
          </span>
        ))}
      </motion.div>
    </div>
  );
}
